import { render, staticRenderFns } from "./LoginLK.vue?vue&type=template&id=2ed28107&scoped=true&"
import script from "./LoginLK.vue?vue&type=script&lang=js&"
export * from "./LoginLK.vue?vue&type=script&lang=js&"
import style0 from "./LoginLK.vue?vue&type=style&index=0&id=2ed28107&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed28107",
  null
  
)

export default component.exports